import { Title as MantineTitle } from "@mantine/core";

import { colors } from "#app/theme/v2/colors";
import { fontSizes } from "#app/theme/v2/fontSizes";
import { fontWeights } from "#app/theme/v2/fontWeights";
import { lineHeights } from "#app/theme/v2/lineHeights";

type TitleProps = {
  children: React.ReactNode;
  size?: "large" | "medium" | "small" | "tiny";
  style?: React.CSSProperties;
  color?: string;
};

const TITLE_LINE_HEIGHTS = {
  large: lineHeights[2.25],
  medium: lineHeights[2],
  small: lineHeights[1.75],
  tiny: lineHeights[1.5],
};

const Title = ({ children, size = "medium", style, color }: TitleProps) => {
  const c = color ?? colors.text.primaryDefault;
  switch (size) {
    case "large":
      return (
        <MantineTitle
          order={1}
          fw={fontWeights.medium}
          style={style}
          fz={fontSizes[32]}
          lh={TITLE_LINE_HEIGHTS.large}
          lts="-2.3%"
          c={c}
        >
          {children}
        </MantineTitle>
      );
    case "medium":
      return (
        <MantineTitle
          order={2}
          fw={fontWeights.medium}
          style={style}
          c={c}
          fz={fontSizes[26]}
          lh={TITLE_LINE_HEIGHTS.medium}
          lts="-1.8%"
        >
          {children}
        </MantineTitle>
      );
    case "small":
      return (
        <MantineTitle
          order={3}
          c={c}
          fw={fontWeights.medium}
          style={style}
          fz={fontSizes[22]}
          lh={TITLE_LINE_HEIGHTS.small}
          lts="-1.3%"
        >
          {children}
        </MantineTitle>
      );
    case "tiny":
      return (
        <MantineTitle
          order={4}
          c={c}
          fw={fontWeights.medium}
          style={style}
          fz={fontSizes[18]}
          lh={TITLE_LINE_HEIGHTS.tiny}
          lts="-0.6%"
        >
          {children}
        </MantineTitle>
      );
  }
};

export { Title, TITLE_LINE_HEIGHTS };
